let DEBUG_MODE_ON: boolean = false;

export const setDebugMode = (debug: boolean): void => {
  DEBUG_MODE_ON = debug;
  if (debug) {
    console.log("[L9RUM Browser SDK] Debug mode is enabled");
  }
};

export const log = (...args: unknown[]): void => {
  if (DEBUG_MODE_ON) {
    console.log(...args);
  }
};

export const warn = (...args: unknown[]): void => {
  if (DEBUG_MODE_ON) {
    console.warn(...args);
  }
};

export const error = (...args: unknown[]): void => {
  if (DEBUG_MODE_ON) {
    console.error(...args);
  }
};
